var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEvents = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#868686;}")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#868686"
    },
    d: "M17.8,13.2h-6v6h6ZM16.6,0V2.4H7V0H4.6V2.4H3.4A2.39,2.39,0,0,0,1,4.79H1V21.6A2.39,2.39,0,0,0,3.4,24H20.2a2.41,2.41,0,0,0,2.4-2.4V4.8a2.41,2.41,0,0,0-2.4-2.4H19V0Zm3.6,21.6H3.4V8.4H20.2Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEvents, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/events.dc3f6da6.svg";
export { ForwardRef as ReactComponent };